import { FREEHOLDER, LANDLORD, LEASEHOLDER, MANAGER, OTHER_OCCUPANT, OWNER_OCCUPIER, TENANT, } from '../constants/contactTypes';
export const getResidentLandlords = (contacts) => {
    if (!contacts)
        return [];
    return contacts.filter((contact) => contact.contact_type_id === OWNER_OCCUPIER.id ||
        contact.contact_type_id === LANDLORD.id);
};
export const getTenants = (contacts) => {
    if (!contacts)
        return [];
    return contacts.filter((contact) => contact.occupant && contact.occupant.tenant);
};
export const isOccupant = (contact) => contact &&
    (contact.contact_type_id === TENANT.id ||
        contact.contact_type_id === OTHER_OCCUPANT.id);
export const isTenant = (contact) => contact && contact.contact_type_id === TENANT.id;
export const getOccupants = (contacts) => {
    if (!contacts)
        return [];
    return contacts.filter(isOccupant);
};
export const isManager = (contact) => contact && contact.contact_type_id === MANAGER.id;
export const getManagers = (contacts) => {
    if (!contacts)
        return [];
    return contacts.filter(isManager);
};
export const isOwner = (contact) => contact &&
    (contact.contact_type_id === OWNER_OCCUPIER.id ||
        contact.contact_type_id === LANDLORD.id ||
        contact.contact_type_id === FREEHOLDER.id ||
        contact.contact_type_id === LEASEHOLDER.id);
export const getOwners = (contacts) => {
    if (!contacts)
        return [];
    return contacts.filter(isOwner);
};
export const getNextHouseholdReference = (households) => {
    const numbers = households
        .map((h) => parseInt(h.reference.replace(/\D/g, ''), 10))
        .filter((n) => !isNaN(n));
    const value = numbers.length ? Math.max(...numbers) + 1 : 1;
    return `HH-${value}`;
};
